import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const DesignEditorHeaderCenterSlot = ({ className, children }) => {
  const classes = classNames({
    'design-editor-header-center': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

DesignEditorHeaderCenterSlot.propTypes = propTypes;

export default DesignEditorHeaderCenterSlot;
